export const AUTH_LOGIN_URL = '/login';
export const AUTH_REGISTER_URL = '/register';
export const AUTH_FORGOT_PASSWORD_URL = '/forgot';
export const AUTH_VERIFY_EMAIL_URL = '/verify';

export const DASHBOARD_URL = '/';

export const COURSES_URL = '/courses';
export const COURSE_DETAILS_URL = `${COURSES_URL}/detail`;
